<div class="container-fluid">
  <div class="col-md-12 pt-4 pb-4">
    <app-faq-article-display [article]="article" [showFooter]="false"></app-faq-article-display>
  </div>
</div>

